<template>
  <v-row justify="center">
    <template>
      <v-btn color="lime" dark @click="openDialog()" rounded>
        <v-icon left dark>mdi-plus-circle-outline</v-icon> Régions supervisées
      </v-btn>
    </template>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="headline">
          Régions supervisées par {{ user.displayName }}
        </v-card-title>
        <v-card-text>
          <template>
            <v-card class="mx-auto elevation-0">
              <template>
                <v-container fluid>
                  <v-row align="center">
                    <v-col cols="12">
                      <v-select
                        ref="regionSelectedRef"
                        v-model="regionsSelected"
                        :items="regionsList"
                        label="Selectionnez les régions"
                        multiple
                        persistent-hint
                        item-text="ll_region"
                        return-object
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
            </v-card>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" dark @click="dialog = false" rounded>
            Annuler
          </v-btn>
          <v-btn
            color="green darken-1"
            dark
            @click="addRegionsSuperviseesToUser()"
            rounded
            :loading="saveloading"
          >
            Sauvegarder
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {},
  props: {
    user: {
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      regionsSelected: Array.isArray(this.user.regionsSupervisees)
        ? this.user.regionsSupervisees
        : [],
      saveloading: false,
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },

    addRegionsSuperviseesToUser() {
      let self = this;
      this.saveloading = true;
      let regionSelectednew = [];
      _.forEach(this.regionsSelected, function (item) {
        regionSelectednew.push({ ...item });
      });
      //console.log(regionSelectednew);

      var usersRef = this.$firebase
        .firestore()
        .collection("users")
        .doc(this.user.id);
      if (regionSelectednew.length > 0) {
        usersRef
          .set(
            {
              regionsSupervisees: regionSelectednew,
            },
            { merge: true }
          )
          .then(function () {
            console.log("Document successfully written!");
            self.regionsSelected = regionSelectednew;
            //self.GetIdentifiantsAll();
            self.saveloading = false;
            self.dialog = false;
          })
          .catch(function (error) {
            console.error("Error writing document: ", error);
          });
      } else {
        console.log("tableau vide");
        usersRef
          .set({ regionsSupervisees: [] }, { merge: true })
          .then(function () {
            console.log("Document successfully updated!");
            self.GetIdentifiantsAll();
            self.saveloading = false;
            self.dialog = false;
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
          });
      }
    },

    ...mapActions({}),
  },
  computed: {
    ...mapState({
      regionsList: (state) => state.Regions.Regions,
      AdminNavigation: (state) => state.Navigation.AdminNavigation,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
